import script from "./ShippingQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingQuote.vue?vue&type=script&setup=true&lang=js"

import "./ShippingQuote.vue?vue&type=style&index=0&id=69d8967e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d8967e"]])

export default __exports__